// src/api/axiosInstance.js
import axios from "axios";

// Limpia el slash final
import { getApiBase } from "../context/api";

const baseURL = getApiBase();

const api = axios.create({
  baseURL,
});

// API Base URL configured

export default api;
